<template>
  <app-panel title="История отправки" class="employee-debtors-sms-history" flex>
    <div class="employee-debtors-sms-history__content">
      <grid-infinite-scroll ref="table"
                            :columns="columns"
                            :getData="getHistory"
                            :maxConcurrentDatasourceRequests="4"
                            :pageSize="50"
                            :rowHeight="50"
                            :filterable="false"
                            :sortable="false"
                            noRowsText="История не найдена"/>
    </div>
  </app-panel>
</template>

<script>
  import FileRenderer from "@/components/debtors/sms/FileRenderer";

  export default {
    name: "SendHistory",
    data(){
      return {
        columns: [
          {
            headerName: 'Дата добавления',
            field: 'created_at',
            filter: false,
            minWidth: 120,
            suppressSizeToFit: false,
            editable: false,
            valueGetter: ({data}) => {
              return data.created_at ? this.$options.filters.moment(this.$parseDateFromString(data.created_at.split(" ")[0])) : '-';
            },
          },
          {
            headerName: 'Пользователь',
            field: 'user',
            filter: false,
            minWidth: 120,
            suppressSizeToFit: false,
            editable: false,
            valueGetter: ({data}) => {
              return data.user ? data.user.name : '-';
            },
          },
          {
            headerName: 'Файл',
            field: 'file',
            filter: false,
            minWidth: 120,
            suppressSizeToFit: false,
            editable: false,
            valueGetter: ({data}) => {
              return data.file ? data.file.name : '-';
            },
            cellRendererFramework: FileRenderer,
            cellRendererParams: ({data}) => data
          },
          {
            headerName: 'Кол-во смс',
            field: 'sms',
            filter: false,
            minWidth: 120,
            editable: false,
            valueGetter: ({data}) => {
              return data.sms ? data.sms.length : '-';
            },
          },
        ]
      }
    },
    computed: {
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      },
    },
    methods: {
      updateData(){
        this.$refs.table.resetData();
      },
      getHistory(page, filters, orderBy) {
        return new Promise(async (resolve) => {
          let {data} = await this.$http.get('sms/history', {
            params: {
              page: page,
              orderby: orderBy,
              filters: filters,
              buildings_id: this.selectedHouseId,
            }
          });
          resolve({
            response: data,
            total: data.total,
            data: data.data
          })
        });
      },
    },
    watch: {
      selectedHouseId(){
        this.updateData();
      }
    }
  }
</script>

<style lang="scss">
  .employee-debtors-sms-history{
    height: 100%;
    min-height: 620px;

    &__content{
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
</style>
